import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import IconClose from "../../assets/images/deine-buga__image--close.svg";

class Status extends React.Component {
  onClick = null;

  constructor(props) {
    super(props);
    this.onClick = props.onClick;
  }


  state = {
    isOpen: this.props.isVisible
  };

  static propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    approvePhrase: PropTypes.string,
    onClick: PropTypes.func,
    selfCloseOption: PropTypes.bool,
    isVisible: PropTypes.bool.isRequired
  };

  static defaultProps = {
    selfCloseOption: true
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.isVisible !== prevProps.isVisible && this.props.isVisible !== prevState.isOpen) {
      console.log("C:Status|M:componentDidUpdate: change is Visible.");
      this.setState({
        isOpen: this.props.isVisible
      });
    }
  }

  handleClose = () => {
    this.setState({
      isOpen: false
    });
  };

  render() {
    const { children, title, approvePhrase, onClick, selfCloseOption } = this.props;

    const { isOpen } = this.state;

    // Show the Status only if it's set to visible:
    if (!isOpen) {
      return null;
    }

    return (
      <StatusWrapper>
        {selfCloseOption && <StatusClose onClick={this.onClick || this.handleClose} />}
        {title && <StatusTitle>{title}</StatusTitle>}
        {children && <StatusBody>{children}</StatusBody>}
        {approvePhrase && <StatusApprove onClick={this.onClick || this.handleClose}>{approvePhrase}</StatusApprove>}
      </StatusWrapper>
    );
  }
}

const StatusWrapper = styled.div.attrs({
  className: "status flex flex-column w-100 h-100 relative overflow-visible"
})`
  background-color: rgba(255, 255, 255, 0.9);
  pointer-events: all;
`;

const StatusTitle = styled.h3.attrs({ className: "ph4 pv2 f3" })``;

const StatusBody = styled.div.attrs({
  className: "flex-grow-1 flex flex-column content-center justify-center tc"
})``;

const StatusApprove = styled.button.attrs({
  className: "center ph4 pv3 mv4 ba bg-white"
})`
  border-color: rgba(129,51,78, 1);
`;

const StatusClose = styled.button.attrs({
  className: "absolute right-0 top-0 ma2 pointer tc bn z-1"
})`
  background-image: url(${IconClose});
  background-size: contain;
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;
  background-color: transparent;
`;

export default Status;
